import { discountHandlers } from "./Discounts/handlers";
import { flightHandlers } from "./Flights/handlers";
import { giftCardHandlers } from "./GiftCards/handlers";
import { userHandlers } from "./User/handlers";

const handlers = [...userHandlers, ...flightHandlers, ...giftCardHandlers, ...discountHandlers];

export { handlers };
